// This file is auto-generated by 'scripts/generateIconComponents.ts'. Do not edit it manually.

import { Icon, type IconProps } from '@chakra-ui/react/icon';
import { type Ref } from 'react';

import SVG16 from '../svgs/16x16/icon-check-16.svg?react';
import SVG24 from '../svgs/24x24/icon-check-24.svg?react';
import { bitkitIcon } from './bitkitIcon';

export interface IconCheckProps extends IconProps {
  size?: '16' | '24';
}

const IconCheck = bitkitIcon(function IconCheck({ size = '24', ...props }: IconCheckProps, ref: Ref<SVGSVGElement>) {
  if (size === '16') {
    return (
      <Icon asChild ref={ref} {...props}>
        <SVG16 width="16" height="16" />
      </Icon>
    );
  }

  return (
    <Icon asChild ref={ref} {...props}>
      <SVG24 width="24" height="24" />
    </Icon>
  );
});

IconCheck.displayName = 'IconCheck';

export default IconCheck;
